module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "mask-fade"
    }
  }, [(_vm.show) ? _c('div', {
    class: ['modal-backdrop', 'bg-' + _vm.color],
    style: (_vm.styles)
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3334f6a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/masker.vue
// module id = 521
// module chunks = 84